export default __webpack_public_path__ + "static/course4-64609998c8238ec72829937620d68a22.jpg";